<template>
  <div class="dropdown-menu" aria-labelledby="dropdownMenuClickableOutside">
    <div>
      <ul>
        <!-- <li><a class="purchase-item dropdown-item nav-link nav_item" v-b-modal:depositViaPhoneCardModal>NẠP QUA THẺ ĐIỆN THOẠI</a></li> -->
        <li><a :href="route('fe.view_nap_card', {domain: website.domain})" class="purchase-item dropdown-item nav-link nav_item" >NẠP QUA THẺ ĐIỆN THOẠI</a></li>
        <li :hidden="false"><a class="purchase-item dropdown-item nav-link nav_item" v-b-modal:depositViaATM >NẠP QUA ATM TẶNG {{ settings.discount_atm }}% </a></li>
        <li :hidden="false"><a class="purchase-item dropdown-item nav-link nav_item" v-b-modal:depositViaMOMO >NẠP QUA MOMO TẶNG {{ settings.discount_momo }}% </a></li>
      </ul>
    </div>
    <deposit-via-phone-card-v3
        :website="website"
        :settings="settings"
    >
    </deposit-via-phone-card-v3>

    <deposit-via-momo-v3
        :website="website"
        :settings="settings"
        :wallets="wallets"
        :user="user"
    >
    </deposit-via-momo-v3>
    <deposit-via-atm-v3
        :website="website"
        :settings="settings"
        :wallets="wallets"
        :user="user"
    >
    </deposit-via-atm-v3>
  </div>
</template>

<script>
export default {
  props: {
    website: {
      Type: Object,
      default() {
        return {};
      }
    },
    user: {
      Type: Object,
      default() {
        return {};
      }
    },
    wallets: {
      Type: Array,
      default() {
        return [];
      }
    },
    settings: {
      Type: Object,
      default() {
        return {};
      }
    },
  },
  data() {
    return {
      card: {
        card_brand: '',
        value: '',
        code: '',
        serial: ''
      }
    }
  },
  methods: {
    async handleConfirm() {
      await this.$swal.fire({
        title: 'Xác nhận!',
        text: 'Bạn thực sự muốn nạp thẻ này?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Nạp ngay`,
        denyButtonText: `Huỷ`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$bvToast.toast(`Toast with action link`, {
            href: '#foo',
            title: 'Example',
            variant: 'danger',
            solid: true,
            appendToast: 'b-toaster-top-right'
          })
          // this.handleSendCard();
        }
      })
    },
    async handleSendCard() {
      try {
        const uri = this.route('fe_card_charge', {domain: this.website.domain});
        const response = await this.Request.post(uri, this.card);
        console.log(response);

        if (response.data.status === false) {
          this.$swal.fire(
              'Có lỗi xảy ra!',
              response.data.message,
              'error'
          );

        } else {
          this.$swal.fire(
              'Thành Công!',
              response.data.message,
              'success'
          );
        }
      } catch (e) {
        console.log(e); // eslint-disable-line
        const errorMessages = this.Request.errors(e.response);
        errorMessages.forEach((value) => {
          this.$bvToast.toast(value, {
            title: `Lỗi`,
            variant: 'danger',
            solid: true
          });
        });
      }
    }
  }
}
</script>
